import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { RFQ, RfqService } from '@app/core/quotes';

import { RfqFormVariantsComponent } from '../rfq-form-variants/rfq-form-variants.component';

@Component({
  selector: 'cnc-edit-rfq-variants',
  templateUrl: './edit-rfq-variants.component.html',
  styleUrls: ['./edit-rfq-variants.component.scss'],
})
export class EditRfqVariantsComponent implements OnInit, OnDestroy {
  @Input() rfq :any;

  variants :any[] = [];
  loading :boolean = false;
  private onDestroy$ = new Subject();

  selectedVariantTerms :any = {};

  constructor(
    public activeModal :NgbActiveModal,
    private modalSvc :NgbModal,
    private cd :ChangeDetectorRef,
    private rfqService :RfqService,
    private toastr :ToastrService,
    private translate :TranslateService,
  ) {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  ngOnInit() {
    this.variants = this.rfq.product_variants.filter((productVariant) => {
      return typeof productVariant !== 'string';
    });

    if (this.rfq.variant_parent_id > 0) {
      this.variants = JSON.parse(this.rfq.parent.product_variants).filter(
        (productVariant) => {
          return typeof productVariant !== 'string';
        },
      );

      //set condition if this.rfq.product_variants is empty or not
      if (this.variants.length > 0) {
        const childVariants = this.rfq.product_variants.filter((productVariant) => {
          return typeof productVariant !== 'string';
        });

        if (childVariants && childVariants.length > 0) {
          childVariants.forEach((row) => {
            this.selectedVariantTerms[row.variant_name] = row.variant_terms[0];
          });
        } else {
          this.variants.forEach((row) => {
            this.selectedVariantTerms[row.variant_name] = '';
          });
        }
      } else {
        this.getSkuById(this.rfq.parent.id).subscribe();
      }
    }
  }

  private getSkuById(id :number) :Observable<any> {
    return this.rfqService.getById(id).pipe(
      tap((rfqs) => {
        if (rfqs) {
          this.variants = JSON.parse(rfqs.product_variants).filter(
            (productVariant) => {
              return typeof productVariant !== 'string';
            },
          );
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  addVariant(variant ?:any, idx ?:number) {
    const modalRef = this.modalSvc.open(RfqFormVariantsComponent, {});
    modalRef.componentInstance.selectedVariants = this.variants;
    if (variant) {
      modalRef.componentInstance.variant = variant;
    }
    modalRef.result.then(
      (data) => {
        if (idx >= 0) {
          this.variants.splice(idx, 1, data);
        } else {
          this.variants.push(data);
        }
        this.cd.detectChanges();
      },
      (_) => {},
    );
  }

  updateRfqVariants() {
    const fd = new FormData();

    // for variants skus
    if (this.rfq.variant_parent_id > 0) {
      const variants = Object.keys(this.selectedVariantTerms).map((key) => {
        return {
          variant_name: key,
          variant_terms: [this.selectedVariantTerms[key]],
        };
      });
      fd.append('product_variants', JSON.stringify(variants));
    } else {
      fd.append('product_variants', JSON.stringify(this.variants));
    }

    if (this.rfq.variant_parent_id === 0) {
      Swal.fire({
        title: 'Confirm Update?',
        text: 'NOTE: Some updated or deleted Variant/Variant Terms will reappear again if there are active Variant SKUs that are still using it',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Update it!',
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.rfqService.updateRfqVariants(this.rfq.id, fd).subscribe(
            (resp :any) => {
              if (resp.record) {
                this.toastr.success(
                  this.translate.instant('MESSAGES.UPDATE_SUCCESS.TEXT'),
                  this.translate.instant('MESSAGES.UPDATE_SUCCESS.TITLE'),
                );
                this.activeModal.close(resp);
                this.loading = false;
                this.cd.detectChanges();
              }
            },
            (errorResp :any) => {
              Swal.fire({
                title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
                text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
                type: 'error',
                confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
              }).then((data) => {
                this.loading = false;
              });
            },
          );
        }
      });
    } else {
      this.loading = true;
      this.rfqService.updateRfqVariants(this.rfq.id, fd).subscribe(
        (resp :any) => {
          if (resp.record) {
            this.toastr.success(
              this.translate.instant('MESSAGES.UPDATE_SUCCESS.TEXT'),
              this.translate.instant('MESSAGES.UPDATE_SUCCESS.TITLE'),
            );
            this.activeModal.close(resp);
            this.loading = false;
            this.cd.detectChanges();
          }
        },
        (errorResp :any) => {
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TEXT'),
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          }).then((data) => {
            this.loading = false;
          });
        },
      );
    }
  }
}
